import selectItems from './select-items';
import selectLineTotal from './select-line-total';
import {createSelector} from '@reduxjs/toolkit';

export default createSelector([state => state, selectItems], (state, items) => {
  return items.map(x => selectLineTotal(x)(state));
});
